import { all, call, put, takeLatest, select } from "redux-saga/effects";
import {
  setCategories,
  changeVisibilityOfProductSync,
  removeProductSync,
  cloneProductSync,
  saveProductSync,
} from "./Actions";
import {
  startLoading,
  replaceStoreRequest,
  replaceStoreSuccess,
  stopLoading,
} from "../Store/Actions";
import { toast } from "react-toastify";
import {
  saveProduct as updateProduct,
  saveProducts as updateProducts,
  api,
  saveStore,
} from "../../../Services/Api";

function* removeProduct({ productId, categoryId }) {
  yield runSave(
    "Categoria excluido com sucesso!",
    "Erro ao excluir produto!",
    function* () {
      yield call(api.delete, "/menu/products", {
        data: { productId: productId, categoryId: categoryId },
      });

      yield put(removeProductSync(productId));
    }
  );
}

function* cloneProduct({ productId }) {
  yield runSave(
    "Produto duplicado com sucesso!",
    "Erro ao duplicar produto!",
    function* () {
      const { data: product } = yield call(
        api.post,
        `menu/products/${productId}/clone`
      );

      yield put(cloneProductSync(product));
    }
  );
}

function* saveProduct({ productId, productData }) {
  yield runSave(
    "Salvo com sucesso!",
    "Erro ao salvar!",
    function* () {
      yield call(api.put, `/menu/products/${productId}/info`, {
        printDescription: productData.printDescription,
        price: Number(productData.price),
        details: productData.details || "",
      });
      yield put(saveProductSync(productData));
    },
    true
  );
}

function* saveProducts({ products }) {
  yield put(startLoading());
  const store = yield select((state) => state.store);

  const getStoreUpdated = (savedProducts) => {
    const menu = store.menu.map((cat) => {
      if (!savedProducts.length) return cat;
      if (cat._id === savedProducts[0].categoryId) cat.itens = savedProducts;
      return cat;
    });
    return { ...store, menu };
  };

  try {
    const response = yield call(updateProducts, products);
    yield put(replaceStoreSuccess(getStoreUpdated(response)));
  } catch (err) {
    yield put(stopLoading());
    toast.error("Erro ao salvar!");
  }
}

function* changeVisibilityProduct({ id, visibility }) {
  yield runSave(
    "Produto alteraco com sucesso!",
    "Erro ao alterar produto!",
    function* () {
      yield call(api.put, `/menu/products/${id}/visibility`, {
        visibility: visibility,
      });
      yield put(changeVisibilityOfProductSync(id, visibility));
    }
  );
}

function* addCategory({ categoryName }) {
  yield runSave(
    "Categoria criada com sucesso!",
    "Erro ao criar categoria!",
    function* () {
      yield call(api.post, "/menu/categories", {
        nameShow: categoryName,
      });
      const { data: categories } = yield call(api.get, "/menu/categories");
      yield put(setCategories(categories));
    }
  );
}

function* renameCategory({ id, categoryName }) {
  yield runSave(
    "Categoria alterada com sucesso!",
    "Erro ao alterar categoria!",
    function* () {
      yield call(api.put, `/menu/categories/${id}/rename`, {
        nameShow: categoryName,
      });
      const { data: categories } = yield call(api.get, "/menu/categories");
      yield put(setCategories(categories));
    }
  );
}

function* changeVisibilityCaregory({ id, visibility }) {
  yield runSave(
    "Categoria alterada com sucesso!",
    "Erro ao alterar categoria!",
    function* () {
      yield call(api.put, `/menu/categories/${id}/visibility`, {
        is_active: visibility,
      });
      const { data: categories } = yield call(api.get, "/menu/categories");
      yield put(setCategories(categories));
    }
  );
}

function* removeCategory({ id }) {
  yield runSave(
    "Categoria removida com sucesso!",
    "Erro ao remover categoria!",
    function* () {
      yield call(api.delete, "/menu/categories/" + id);
      const { data: categories } = yield call(api.get, "/menu/categories");
      yield put(setCategories(categories));
    }
  );
}

function* loadMenu() {
  try {
    const { data: categories } = yield call(api.get, "/menu/categories");
    yield put(setCategories(categories));
  } catch (err) {
    console.log(err);
    toast.error("Erro ao carregar Cardápio");
  }
}

function* runSave(successMessage, errorMessage, fnc, loading = false) {
  try {
    if (loading) yield put(startLoading());
    yield fnc();
    if (loading) yield put(stopLoading());
    toast.success(successMessage);
  } catch (err) {
    if (loading) yield put(stopLoading());
    toast.error(errorMessage);
  }
}

export default all([
  takeLatest("LOAD_MENU", loadMenu),
  takeLatest("REMOVE_PRODUCT", removeProduct),
  takeLatest("REMOVE_CATEGORY", removeCategory),
  takeLatest("SAVE_PRODUCT", saveProduct),
  takeLatest("SAVE_PRODUCTS", saveProducts),
  takeLatest("CLONE_PRODUCT", cloneProduct),
  takeLatest("CHANGE_VISIBILITY_PRODUCT", changeVisibilityProduct),
  takeLatest("RENAME_CATEGORY", renameCategory),
  takeLatest("CHANGE_VISIBILITY_CATEGORY", changeVisibilityCaregory),
  takeLatest("ADD_CATEGORY", addCategory),
]);
